import type { VectorValue as VectorValueType } from "@/lib/node-description/value-types"
import { toVectorValue } from "@/lib/node-description/value-types"
import { ConnectedValuePill, ScalarValuePill } from "./pills"

export const VectorValue = ({
	paramName,
	value,
	isConnected,
	sourceLabel,
	onChange,
	showLabel: _showLabel = true,
	variant = "canvas",
	disabled = false,
}: {
	paramName: string
	value: unknown
	isConnected: boolean
	sourceLabel?: string
	onChange: (value: VectorValueType) => void
	showLabel?: boolean
	variant?: "canvas" | "sidebar" | "named"
	disabled?: boolean
}) => {
	const vectorValue = toVectorValue(value, { x: 0, y: 0, z: 0 })

	const handleComponentChange = (axis: "x" | "y" | "z", newValue: number) => {
		onChange({ ...vectorValue, [axis]: newValue })
	}

	if (isConnected && variant !== "named") {
		return (
			<ConnectedValuePill
				label={
					sourceLabel || paramName.charAt(0).toUpperCase() + paramName.slice(1)
				}
				variant={variant}
			/>
		)
	}

	return (
		<span className="relative inline-flex items-center gap-x-[5px]">
			<ScalarValuePill
				value={vectorValue.x}
				type="number"
				variant={variant}
				disabled={disabled}
				onChange={(val) => handleComponentChange("x", Number(val))}
			/>
			<ScalarValuePill
				value={vectorValue.y}
				type="number"
				variant={variant}
				disabled={disabled}
				onChange={(val) => handleComponentChange("y", Number(val))}
			/>
			<ScalarValuePill
				value={vectorValue.z}
				type="number"
				variant={variant}
				disabled={disabled}
				onChange={(val) => handleComponentChange("z", Number(val))}
			/>
		</span>
	)
}
